import { render, staticRenderFns } from "./supportmain.vue?vue&type=template&id=7594d95d&scoped=true"
import script from "./supportmain.vue?vue&type=script&lang=js"
export * from "./supportmain.vue?vue&type=script&lang=js"
import style0 from "./supportmain.vue?vue&type=style&index=0&id=7594d95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7594d95d",
  null
  
)

export default component.exports